// Server timestamps are naive UTC; force UTC interpretation.
export const parseServerDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = typeof value === 'string' ? value : String(value);
  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  return new Date(`${s}Z`);
};

export const formatRelativeTime = (value) => {
  const d = parseServerDate(value);
  if (!d || isNaN(d.getTime())) return '—';
  const diff = Date.now() - d.getTime();
  const seconds = Math.max(0, Math.floor(diff / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

export const formatAbsoluteDate = (value) => {
  const d = parseServerDate(value);
  if (!d || isNaN(d.getTime())) return '—';
  return d.toLocaleString();
};
